export function hasAdminAccess(user) {
  return user?.status === "active" && user?.role === "admin";
}
